(function ($) {

  const initializeBlock = function ($block) {
    var viewport = document.documentElement.clientWidth

    function adjustHeight() {
      var minHeight = 0
      var defaultDesktopImage = $block.find('.accordionMedia-default_desktop_image').outerHeight()

      if (viewport > 1139) {
        if (defaultDesktopImage > minHeight) {
          minHeight = defaultDesktopImage
        }

        $block.find('.mediaContainer').each(function(index, el) {
          var mediaHeight = $(this).outerHeight()

          if (mediaHeight > minHeight) {
            minHeight = mediaHeight
          }
        });
      } else {
        minHeight = 0
      }

      $block.find('.accordionMedia').css('min-height', minHeight + 'px');
    }

    adjustHeight();

    $( window ).bind('resize orientationchange', function() {
      adjustHeight();
    });

    $('.accordionMedia-item__title').click(function(event) {
      event.preventDefault()
      event.stopPropagation()

      if ($(this).parent().hasClass('active')) {
        $(this).parent().removeClass('active')
        $block.find('.accordionMedia-default_desktop_image').addClass('active')
      } else {
        $block.find('.accordionMedia-item, .accordionMedia-default_desktop_image').removeClass('active')
        $(this).parent().addClass('active')
      }
    });
  }

  $(document).ready(function () {
    $('.block--accordion-media').each(function () {
      initializeBlock($(this));
    })
  })

  if (window.acf) {
    window.acf.addAction('render_block_preview/type=accordion-media', initializeBlock);
  }

})(jQuery);
